import React, { useCallback, useEffect, useState } from "react"

import { cdsBroadcastChannel, getCheckoutPaymentInfo } from "utils"
import CdsCheckoutSummary from "./CdsCheckoutSummary"
import CdsSuccessPage from "./CdsSuccessPage"
import CdsCheckoutContents from "./CdsCheckoutContents"
import classes from "./index.module.scss"

const CdsCheckout = () => {
  const [orderItems, setOrderItems] = useState([])
  const [orderCombos, setOrderCombos] = useState([])
  const [discounts, setDiscounts] = useState([])
  const [deliveryFees, setDeliveryFees] = useState(null)
  const [deliveryType, setDeliveryType] = useState("dineIn")
  const [showSuccessPage, setShowSuccessPage] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")

  const validateIframeMessage = (event) => {
    if (process.env.NODE_ENV === "production") {
      if (!event.origin.includes("pos.")) return false

      const iframeWindowParentHost =
        window.location.host.split("pos.")[1]

      if (!event.origin.includes(iframeWindowParentHost)) return false
    }

    return true
  }

  const clearCds = () => {
    setOrderItems([])

    setOrderCombos([])

    setDiscounts([])

    setDeliveryFees(null)

    setDeliveryType("dineIn")
  }

  const checkoutChanges = (data) => {
    !!data.orderItems &&
      setOrderItems(data.orderItems)

    !!data.deliveryType &&
      setDeliveryType(data.deliveryType)

    !!data.discounts &&
      setDiscounts(data.discounts)

    setDeliveryFees(data.deliveryFees || null)
  }

  const handleShowSuccessPage = (data) => {
    setShowSuccessPage(true)

    setSuccessMessage(data.message || "")

    clearCds()
  }

  const handleCdsMessages = useCallback((event) => {
    if (!validateIframeMessage(event)) return

    switch (event.data?.type) {
      case "checkoutChanges": {
        checkoutChanges(event.data)
        break
      }
      case "clear": {
        clearCds()
        break
      }
      case "success": {
        handleShowSuccessPage(event.data)
        break
      }
      default: break
    }
  }, [])

  useEffect(() => {
    const bc =
      cdsBroadcastChannel.create()

    bc.addEventListener("message", handleCdsMessages)

    return () => {
      bc.removeEventListener("message", handleCdsMessages)
    }
  }, [])

  const {
    total,
    subtotal,
    taxesAndCharges,
    totalFoodDiscounts,
    totalDeliveryDiscountByCoupon,
    totalDeliveryFeeBeforeDiscount
  } = getCheckoutPaymentInfo(
    orderItems,
    orderCombos,
    discounts,
    deliveryFees,
    deliveryType
  )

  if (showSuccessPage) {
    return (
      <CdsSuccessPage
        successMessage={successMessage}
        setShowSuccessPage={setShowSuccessPage}
      />
    )
  }

  return (
    <div className={classes["container"]}>
      <CdsCheckoutContents
        orderItems={orderItems}
        successMessage={successMessage}
      />

      <CdsCheckoutSummary
        total={total}
        subtotal={subtotal}
        taxesAndCharges={taxesAndCharges}
        totalFoodDiscounts={totalFoodDiscounts}
        totalDeliveryDiscountByCoupon={totalDeliveryDiscountByCoupon}
        totalDeliveryFeeBeforeDiscount={totalDeliveryFeeBeforeDiscount}
      />
    </div>
  )
}

export default CdsCheckout